import { Link } from "react-router-dom";

const LOGO_URL =
  "https://static.readdy.ai/image/9bd046423ff55e49be43d604c216515f/748f9bdfc4c6ea0c2a13ac200d412f03.png";

export default function HeroSection() {
  return (
    <section
      className="relative min-h-screen flex items-center overflow-hidden"
      style={{ background: "#0A0A0A" }}
    >
      {/* Background image */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/b44fbed3c67d66a0f49bd2f1df163c76.jpg"
          alt=""
          className="w-full h-full object-cover object-top opacity-25"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-black via-black/80 to-black/40" />
        <div className="absolute inset-0 bg-gradient-to-t from-black via-transparent to-black/60" />
      </div>

      {/* Animated gold particles */}
      <div className="absolute inset-0 z-0 pointer-events-none">
        {[...Array(6)].map((_, i) => (
          <div
            key={i}
            className="absolute rounded-full bg-gold/20"
            style={{
              width: `${Math.random() * 4 + 2}px`,
              height: `${Math.random() * 4 + 2}px`,
              left: `${10 + i * 15}%`,
              top: `${20 + (i % 3) * 25}%`,
              animation: `float ${3 + i * 0.5}s ease-in-out infinite`,
              animationDelay: `${i * 0.4}s`,
            }}
          />
        ))}
      </div>

      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-12 pt-28 pb-20">
        <div className="max-w-3xl">
          {/* Logo */}
          <div className="flex items-center gap-4 mb-12 animate-fade-in">
            <div className="w-16 h-16 flex items-center justify-center">
              <img
                src={LOGO_URL}
                alt="LittyCity Agency LLC"
                className="w-16 h-16 object-contain animate-float"
              />
            </div>
            <div className="h-px flex-1 bg-gradient-to-r from-gold/50 to-transparent max-w-xs" />
          </div>

          {/* Tag */}
          <div
            className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full border border-gold/40 mb-8 animate-fade-in"
            style={{ animationDelay: "0.1s" }}
          >
            <span className="w-1.5 h-1.5 rounded-full bg-gold animate-pulse" />
            <span className="text-gold text-xs font-sans font-medium tracking-[0.25em] uppercase">
              Multi-Platform Creator Agency · Est. 2024
            </span>
          </div>

          {/* Headline */}
          <h1
            className="font-display font-black leading-none mb-6 animate-slide-up"
            style={{
              fontSize: "clamp(2.5rem, 6vw, 5rem)",
              animationDelay: "0.2s",
            }}
          >
            Where Creators,{" "}
            <span className="text-gradient-gold">Hosts</span> &amp; Brands{" "}
            <span className="text-gradient-gold gold-glow-text">Stay Lit</span>
          </h1>

          {/* Subheadline */}
          <p
            className="text-white/70 font-sans text-lg md:text-xl leading-relaxed max-w-2xl mb-12 animate-slide-up"
            style={{ animationDelay: "0.35s" }}
          >
            The LittyCity Agency LLC empowers creators with structure, strategy,
            and support across social media platforms, live streaming apps, and beyond.
          </p>

          {/* Buttons */}
          <div
            className="flex flex-col sm:flex-row gap-4 animate-slide-up"
            style={{ animationDelay: "0.5s" }}
          >
            <Link
              to="/join-bigo"
              className="btn-gold inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full text-white font-sans font-semibold text-sm tracking-widest cursor-pointer whitespace-nowrap"
            >
              <i className="ri-user-add-line text-lg" />
              Join Our Creator Network
            </Link>
            <Link
              to="/contact"
              className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full border-2 border-gold text-gold font-sans font-medium text-sm tracking-widest hover:bg-gold hover:text-white transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              <i className="ri-briefcase-line text-lg" />
              Work With Our Agency
            </Link>
          </div>
        </div>

        {/* Scroll indicator */}
        <div className="absolute bottom-10 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
          <span className="text-white/30 text-xs font-sans tracking-widest">
            EXPLORE
          </span>
          <i className="ri-arrow-down-line text-gold/60 text-xl" />
        </div>
      </div>

      {/* Logo background watermark */}
      <div className="absolute inset-0 z-0 flex items-center justify-center pointer-events-none select-none">
        <div className="relative flex items-center justify-center">
          {/* Outer glow ring */}
          <div
            className="absolute rounded-full"
            style={{
              width: "clamp(420px, 52vw, 720px)",
              height: "clamp(420px, 52vw, 720px)",
              background: "radial-gradient(circle, rgba(147,51,234,0.08) 0%, rgba(109,40,217,0.04) 45%, transparent 70%)",
              filter: "blur(40px)",
            }}
          />
          {/* Logo image */}
          <img
            src="https://static.readdy.ai/image/9bd046423ff55e49be43d604c216515f/748f9bdfc4c6ea0c2a13ac200d412f03.png"
            alt=""
            aria-hidden="true"
            style={{
              width: "clamp(340px, 44vw, 620px)",
              height: "clamp(340px, 44vw, 620px)",
              objectFit: "contain",
              opacity: 0.07,
              filter: "drop-shadow(0 0 60px rgba(147,51,234,0.35)) drop-shadow(0 0 120px rgba(192,132,252,0.2)) brightness(1.4) contrast(1.1)",
            }}
          />
        </div>
      </div>

      {/* Right decorative element */}
      <div className="absolute right-0 top-1/2 -translate-y-1/2 w-64 h-64 rounded-full bg-gold/5 blur-3xl pointer-events-none" />
    </section>
  );
}
